export const MELCO_PRESSER_FOOT = "";
export const BERNINA_PRESSER_FOOT = "26,43,44C,45";
export const MELCO_HOOP_VERSION = "2";
export const BERNINA_HOOP_VERSION = "1";
export const MELCO_HOOP_TYPE = "1,2,4,5,6";
export const BERNINA_HOOP_TYPE = "";